import { DEFAULT_INBOX_WIDTH } from "../../constants/inbox/inbox";
import { BlockVisibility, BlockVisibilityType, Visibility } from "../block/enum";
import { inboxActiveTab } from "../inbox/enum";
import { DEFAULT_INBOX_ACCORDION } from "../inbox/type";
import { MOBILE_VIEW_TYPE } from "../main";

export const USER_ROLE = {
  TRIAL: "trial",
  INVITEE: "invitee",
  BELIEVER: "believer",
} as const;
/** Type representing possible user roles */
export type UserRole = (typeof USER_ROLE)[keyof typeof USER_ROLE];

export const CALENDAR_VIEW_TYPE = {
  DAY1: "day",
  DAY3: "day3",
  WEEK: "week",
  MONTH: "month",
} as const;
export type CalendarViewType = (typeof CALENDAR_VIEW_TYPE)[keyof typeof CALENDAR_VIEW_TYPE];

export const SPACE_SHOW = {
  TRUE: true,
  FALSE: false,
} as const;
export type SpaceShow = (typeof SPACE_SHOW)[keyof typeof SPACE_SHOW];

// NOTE Settings Preferences

export const StartOfWeekOption = {
  SUNDAY: "sunday",
  MONDAY: "monday",
} as const;
export type StartOfWeekOption = (typeof StartOfWeekOption)[keyof typeof StartOfWeekOption];

export const TimeFormatOption = {
  HOUR12: "12-hour",
  HOUR24: "24-hour",
} as const;
export type TimeFormatOption = (typeof TimeFormatOption)[keyof typeof TimeFormatOption];

export const DefaultDurationOption = {
  MIN15: "min15",
  MIN30: "min30",
  MIN60: "min60",
} as const;
export type DefaultDurationOption =
  (typeof DefaultDurationOption)[keyof typeof DefaultDurationOption];

// NOTE 서버 값으로 enum 통일 후 사용 시 문자열 값을 숫자로 매핑
export const DefaultDurationValueMap: Record<DefaultDurationOption, number> = {
  [DefaultDurationOption.MIN15]: 15,
  [DefaultDurationOption.MIN30]: 30,
  [DefaultDurationOption.MIN60]: 60,
};

export type SettingsPreferenceType =
  | StartOfWeekOption
  | TimeFormatOption
  | DefaultDurationOption
  | BlockVisibilityType;
